import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { MerchCardShadowColumns, ShadowColumn } from 'pricing-pages-ui-components/components/MerchCardShadowColumns';
import { getMerchCardsToShow, getMerchCardsToShowFTS0017, getStarterCustomerPlatformUpsellCardIndex } from '../../constants/merchCards/MerchCardsToShow';
import { SCREENS } from '../../constants/tracking/Screens';
import { FREE_CARD } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { isUngatedForInbound25Selector } from '../../selectors/GatingSelectors';
import { productsFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { hasAnyTBSkuInProductDataSelector } from '../../selectors/ProductsSelectors';
import { useFTS0017orFTS0018ExperimentEffect } from '../../utils/experiments/fts0017_fts0018';
import { FreeCard } from './cards/FreeCard';
import { HubCard } from './cards/HubCard';
import { UpsellSuiteCard } from './cards/suite/UpsellSuiteCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubTierInfo = ({
  productLine,
  selectedTab
}) => {
  const {
    loading: isLoadingFTS0017orFTS0018Experiment,
    variant: isInFTS0017orFTS0018ExperimentVariant
  } = useFTS0017orFTS0018ExperimentEffect();
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const getProductLevels = () => {
    if (isInFTS0017orFTS0018ExperimentVariant) {
      return getMerchCardsToShowFTS0017({
        tab: selectedTab
      });
    }
    return getMerchCardsToShow({
      tab: selectedTab
    });
  };
  const productLevels = getProductLevels();
  const isAppReady = useGlobalLoading();
  const ownedProducts = useAppSelector(state => {
    if (!isAppReady) return [];
    return productsFromProductInventorySelector(state);
  });
  const isTBEligible = useAppSelector(state => {
    if (!isAppReady) return false;
    return hasAnyTBSkuInProductDataSelector(state);
  });
  const isFreePortal = !selectedTab && (ownedProducts === null || ownedProducts === void 0 ? void 0 : ownedProducts.length) <= 0;
  const isPublic = !!selectedTab;
  const isEnterpriseTab = selectedTab === 'enterprise';
  const showStarterCustomerPlatformUpsellCard = (isFreePortal || isPublic) && isTBEligible && !isEnterpriseTab && !isInFTS0017orFTS0018ExperimentVariant && !isLoadingFTS0017orFTS0018Experiment;
  const starterCustomerPlatformUpsellCardIndex = getStarterCustomerPlatformUpsellCardIndex({
    isPublic
  });

  // if showing UpsellSuiteCard, add 1 to the column count so the grid will have enough columns
  const columnCount = showStarterCustomerPlatformUpsellCard ? productLevels.length + 1 : productLevels.length;
  const merchCardComponents = productLevels.map((productLevel, index) => {
    let columnStart = index + 1;

    // Push merch cards to the right 1 place to make room for UpsellSuiteCard
    if (index >= starterCustomerPlatformUpsellCardIndex) {
      const offset = showStarterCustomerPlatformUpsellCard ? 2 : 1;
      columnStart = index + offset;
    }
    if (productLevel === 'FREE') {
      return /*#__PURE__*/_jsx(FreeCard, {
        productLine: productLine,
        columnStart: columnStart,
        trackingSource: FREE_CARD
      }, `${productLine}-${productLevel}`);
    }
    return /*#__PURE__*/_jsx(HubCard, {
      productLevel: productLevel,
      productLine: productLine,
      selectedTab: selectedTab,
      columnStart: columnStart
    }, `${productLine}-${productLevel}`);
  });
  const shadowColumns = new Array(columnCount).fill('').map((value, index) => {
    // for the second column (UpsellSuiteCard), use a gray background color
    if (showStarterCustomerPlatformUpsellCard && index === starterCustomerPlatformUpsellCardIndex) return /*#__PURE__*/_jsx(ShadowColumn, {
      backgroundColor: "fill-field-default"
    }, index);
    return /*#__PURE__*/_jsx(ShadowColumn, {}, index);
  });
  return /*#__PURE__*/_jsx(PageSection, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsxs(MerchCardShadowColumns, {
      columns: columnCount,
      shadowColumnsComponent: shadowColumns,
      isUngatedForInbound25: isUngatedForInbound25,
      children: [merchCardComponents, showStarterCustomerPlatformUpsellCard ? /*#__PURE__*/_jsx(UpsellSuiteCard, {
        productLine: productLine,
        columnStart: starterCustomerPlatformUpsellCardIndex + 1,
        screen: SCREENS[productLine]
      }) : null]
    })
  });
};
export default HubTierInfo;